import { createSlice } from "@reduxjs/toolkit";
import {
  fetchOrder
} from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const orderSlice = createSlice({
  name: "orderSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrder.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch order List";
      })
  },
});

export default orderSlice.reducer;
